import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { PersonalInfoComponentView } from '../PersonalInfoComponentView';
import { WprBaseViewListModeInfo } from '../../../wpr-framework/mode/WprBaseViewListModeInfo';
// import { ListData } from '../../../sample/models/ListData';
import { TravelerInfo } from '../../../models/TravelerInfo';
import { WprDI_Object } from '../../../wpr-framework/view/di/WprDI_Object';

/**
 * 個人情報登録リストモード
 */
export class PersonalInfoListMode extends WprBaseViewListModeInfo<PersonalInfoComponentView, TravelerInfo>{
	// DI情報  ------------------------------------------------------------------
	@WprDI_Object
	private m_TravelerListInfo: TravelerInfo[] = null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() { super('TravelerInfo'); }
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('表示');
		list.push('非表示');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('copy', { display: [{ mode: '表示', value: true }, { mode: 'other', value: false }] });
	}

	/**
	 * ビューの状態をチェックして行のモードを変更する
	 * @param curMode 現在のモード
	 * @param row 行データ
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckListMode(curMode: string, row: TravelerInfo): string {
		if (this.m_TravelerListInfo.indexOf(row) > 0)
			return '非表示';
		return '表示';
	}
	// --------------------------------------------------------------------------
}